<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <!-- 需要缓存的页面加载方式 -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
      </keep-alive>
      <!-- 不需要缓存的页面加载方式 -->
      <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </div>
  </a-config-provider>
</template>

<script>
//中文包
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
import user from '@/api/user.js'
import modal from 'ant-design-vue/es/modal'
import bureau from './api/bureau'
import checkEnv from './api/checkEnv'
export default {
  name: 'app',
  data() {
    return {
      zh_CN,
    }
  },
  async created() {
    console.log("App created")
    if (checkEnv.locationChanged()) {
      return;
    }
    let initInfo = await this.$store.dispatch('getInit')

    // 一校一案判断
    if (initInfo.isSchoolProject) {
      this.$ls.set('isSchoolProject', initInfo.isSchoolProject)
    }
    if (initInfo.isSchoolProject && !location.href.includes('/school/')) {
      this.$router.push('/school/portal')
      return
    }

    let pageTitle = this.$ls.get('portal')
    if (pageTitle) {
      document.title = pageTitle.title
      document.getElementsByTagName('link')[0].href = pageTitle.favicon
    }
    if (!bureau.getBureauId()) {
      modal.info({
        title: '当前域名错误',
        content: '请前往 www.khsdb.com 进行操作',
        onOk() {
          console.log('跳转')
          window.open('https://www.khsdb.com')
        },
      })
    }

    // 如果是第三方页面跳转 免登录
    if (window.location.href.indexOf('?') != '-1') {
      let thirdUrl = window.location.href.split('?')
      const query = new URLSearchParams(thirdUrl[1])
      if (query.get('flag')) {
        let req = {
          userid: query.get('userid'),
          tick: query.get('tick'),
          sign: query.get('sign'),
          from: query.get('from'),
        }
        console.log('window.location.href.indexOf')
        user.thirdPartyLogin(req).then((res) => {
          console.log('免登录接口----------', res)
          //储存user信息
          this.$ls.set('token', res.accessToken.accessToken)
          this.$ls.set('refreshToken', res.accessToken.refreshToken)
          this.$store.dispatch('getInit').then((res) => {
            console.log('获取的码表信息是：1', res)
          })
          if (res.code == 0) {
            this.$router.push('termSynopsis')
          }
        })
      }
    }
  },
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0px;
  font-family: 'mp-quote', -apple-system-font, BlinkMacSystemFont,
    'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI',
    'Microsoft YaHei', Arial, sans-serif !important;
}

ul,
li {
  padding: 0px;
  margin: 0px !important;
  list-style: none;
}

p {
  margin: 0px !important;
}
</style>
